import { Checkbox } from 'antd';
import styled from 'styled-components';

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;
`;
